export const nameInitialsSplitter = (name: string) => {
	const parts = name.split(' ');
	const firstpart = parts[0] || name[0] || 'X';
	if (parts.length <= 1) {
		return String(firstpart[0]).toLocaleUpperCase();
	}
	const lastpart = parts[parts.length - 1];
	return String(`${firstpart[0]}${lastpart[0]}`).toLocaleUpperCase();
};
